import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Chip } from '@mui/material';
import React from 'react';
const statusMap = {
    active: themeColors.accent.green.bold,
    inactive: themeColors.accent.orange.bold,
    closed: themeColors.accent.red.bold,
    deleted: themeColors.accent.red.bold,
};
export const AccountStatusChip = ({ status, label }) => {
    return (React.createElement(Chip, { sx: { backgroundColor: statusMap[status], color: themeColors.text.inverse }, "data-test": 'status-chip', label: label, size: 'small', variant: 'filled' }));
};
